<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div v-if="target&&Object.keys(target).length" class="main-height">
      <div class="text-indigo-700 font-bold mb-5">{{ target.insertedDateForm }} 社員面接</div>
      <div>
        <!-- 人数 -->
        <div class="flex">
          <div class="m-2">
            <div class="text-gray-700 text-sm font-bold">面接総数</div>
            <div class="border-2 border-green-700 bg-green-50 rounded w-20 py-6 text-center font-bold text-green-800">
              {{ total }}
            </div>
          </div>
          <div class="m-2">
            <div class="text-gray-700 text-sm">採用</div>
            <div class="border bg-blue-100 rounded w-20 py-6 text-center font-bold">
              {{ ok }}
            </div>
          </div>
          <div class="m-2">
            <div class="text-gray-700 text-sm">不採用</div>
            <div class="border bg-blue-100 rounded w-20 py-6 text-center font-bold">
              {{ ng }}
            </div>
          </div>
          <div class="m-2">
            <div class="text-gray-700 text-sm">採用候補</div>
            <div class="border bg-blue-100 rounded w-20 py-6 text-center font-bold">
              {{ candidate }}
            </div>
          </div>
          <div class="m-2">
            <div class="text-gray-700 text-sm">未決</div>
            <div class="border bg-blue-100 rounded w-20 py-6 text-center font-bold">
              {{ pend }}
            </div>
          </div>
        </div>

        <!-- 部署 -->
        <div class="mt-5">
          <div class="text-gray-700 text-sm font-bold">応募部署</div>
          <div class="flex flex-wrap">
            <div v-for="(row, i) in dep" :key="'d'+i" class="m-1 border-2 border-gray-400 rounded">
              <div class="py-2 border-b border-gray-400 text-center text-xs whitespace-nowrap w-28" :class="row.num>0?'bg-yellow-100':'bg-gray-100'">{{ row.name }}</div>
              <div class="py-4 text-center" :class="row.num>0?'':'text-gray-500'">{{ row.num }}</div>
            </div>
          </div>
        </div>

        <!-- 媒体 -->
        <div class="mt-5">
          <div class="text-gray-700 text-sm font-bold">募集媒体</div>
          <div class="flex flex-wrap">
            <div v-for="(row, i) in target.mediumRegular" :key="'m'+i" class="m-1 border-2 border-gray-400 rounded">
              <div class="py-2 border-b border-gray-400 text-center text-xs whitespace-nowrap w-28">{{ row.name }}</div>
              <div class="py-2 text-center">
                <p>{{ row.count }}</p>
                <p class="text-gray-600">（{{ row.rate }} %）</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 応募者 -->
        <div class="flex mt-5 mb-1">
          <div class="ml-5">
            <input 
              id="ok"
              type="checkbox"
              class="" 
              v-model="checkOk"
            />
            <label for="ok" class="pl-3 py-1">採用</label>
          </div>
          <div class="ml-5">
            <input 
              id="ng"
              type="checkbox"
              class="" 
              v-model="checkNg"
            />
            <label for="ng" class="pl-3 py-1">不採用</label>
          </div>
          <div class="ml-5">
            <input 
              id="pend"
              type="checkbox"
              class="" 
              v-model="checkPend"
            />
            <label for="pend" class="pl-3 py-1">未決</label>
          </div>
          
        </div>
        <div class="text-sm border border-gray-300 rounded">
          <table class="w-full">
            <thead>
              <tr class="bg-colu">
                <th v-for="(row, i) in columns" :key="'c'+i" class="p-2 text-left">
                  {{ row.title }}
                </th>
              </tr>
            </thead>
            <tbody v-for="(row, i) in list" :key="i" class="text-gray-800">
              <tr v-if="isShow(row.interviewsResult[0])">
                <td class="p-2">
                  {{ row.interviewsResult[0] ? row.interviewsResult[0].replace('社員', '') : '未決' }}
                </td>
                <td class="p-2">
                  {{ row.isCandidate?'✔':'' }}
                </td>
                <td class="p-2">
                  {{ row.interviewsName }}
                </td>
                <td class="p-2">
                  <div v-if="row.newGrad" class="text-red-500 font-bold">
                    新卒
                  </div>
                  <div v-else>
                    {{ row.interviewsAge }} 歳
                  </div>
                </td>
                <td class="p-2">
                  {{ row.departmentName }}
                </td>
                <td class="p-2">
                  {{ row.interviewsMedium }}
                </td>
                <td class="p-2 cursor-pointer text-blue-700 text-center" @click="openMain(row)">
                  メインタスク表示
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import * as employmentListManager from '@managers/employmentListManager'

export default {
  components: {
    Modal,
  },

  props: ['open', 'target'],

  data() {
    return {
      // ローディング
      loading: false,
      // カラム
      columns: [
        {title: '採否'},
        {title: '採用候補'},
        {title: '名前'},
        {title: '年齢'},
        {title: '応募部署'},
        {title: '募集媒体'},
        {title: ''},
      ],
      // 社員リスト
      list: [],
      // 総数
      total: 0,
      // 採用
      ok: 0,
      // 不採用
      ng: 0,
      // 採用候補
      candidate: 0,
      // 未決
      pend: 0,
      // 部署
      dep: [],
      // チェックボックス
      checkOk: true,
      checkNg: true,
      checkPend: true,
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    /**
     * 初期にリセット
     */
    closed() {
      this.loading = false
      this.list = []
      this.$emit('close')
    },

    /**
     * リスト取得
     */
    async getData() {
      this.loading = true
      this.list = []
      this.dep = []
      if (this.target && this.target.insertedDate) {
        // 社員面接の応募部署などの詳細情報取得
        const res = await employmentListManager.getDetail(this, this.target.insertedDate)
        if (res && res.length) {
          this.list = res
        }
        this.ok = this.target.hireRegular || 0
        this.ng = this.target.rejectRegular || 0
        this.pend = this.target.unresolvedRegular || 0
        this.total = this.ok + this.ng + this.pend

        // 採用候補
        const candidateNum = res.filter((r) => {
          return r.isCandidate
        })
        if (candidateNum && candidateNum.length) {
          this.candidate = candidateNum.length
        } else {
          this.candidate = 0
        }

        // 部署
        const dep = this.$store.getters.departmentList
        let id = {}
        for (let i = 0; i < dep.length; i++) {
          const d = dep[i]
          if (!id[d.departmentId]) {
            id[d.departmentId] = {
              name: d.name,
              num: 0
            }
          }
        }
        for (let i = 0; i < this.list.length; i++) {
          const l = this.list[i]
          if (l.interviewsDepartmentId && l.interviewsDepartmentId[0]) {
            if (id[l.interviewsDepartmentId[0]]) {
              id[l.interviewsDepartmentId[0]].num++
              l.departmentName = id[l.interviewsDepartmentId[0]].name
            }
          }
        }
        for (let i = 0; i < Object.keys(id).length; i++) {
          const key = Object.keys(id)[i]
          this.dep.push(id[key])
        }
        // 多い順に並べ替え
        this.dep.sort(function (a, b) {
          return b.num - a.num
        })
      }
      this.loading = false
    },

    /**
     * 表示、非表示判定
     */
    isShow(val) {
      if (this.checkOk && this.checkNg && this.checkPend) {
        return true
      }
      if (val == '社員不採用') {
        if (this.checkNg) {
          return true
        } else {
          return false
        }
      } else if (val == '社員採用') {
        if (this.checkOk) {
          return true
        } else {
          return false
        }
      } else if (!val) {
        if (this.checkPend) {
          return true
        } else {
          return false
        }
      }
    },

    /**
     * メインタスク表示
     */
    openMain(row) {
      let resolvedRoute = this.$router.resolve({ 
        name: 'RequestPost',
        query: {
          mode: 1,
          requestPostId: row._id
        }
      })
      window.open(resolvedRoute.href, '_blank')
    }
  }
}
</script>
<style scoped>
.main-height {
  height: 85vh;
}

.b-top {
  border-top: 1px solid rgb(228, 227, 227);
}

.bg-colu {
  background: #edecf7;
}

.hover-color:hover {
  background: #edecf7 !important;
}

.title {
  color: #928ec7;
}
</style>